// Profil du joueur — fonctions pures. Comme ZERO SLANG : un avatar (liste fermée), un pseudo, et le lieu trouvé par la
// géolocalisation (pays et ville). Il signe les scores du Hall of Fame ; gardé sur l'appareil, sans mot de passe.
// Les règles du pseudo, de la ville et des avatars sont celles que la fonction submitScore vérifie (functions/src/profile.js).
import { normalizeCountryCode, normalizeCity, validatePseudo, avatarById } from '../../functions/src/profile.js';

export { AVATARS, avatarById, normalizePseudo, validatePseudo, normalizeCity } from '../../functions/src/profile.js';

/** Lieu { countryCode, country?, city? } valide, ou null. */
export function cleanPlace(p) {
  if (!p || typeof p !== 'object') return null;
  const countryCode = normalizeCountryCode(p.countryCode);
  if (!countryCode) return null;
  const place = { countryCode };
  if (typeof p.country === 'string' && p.country.trim()) place.country = p.country.trim().slice(0, 60);
  const city = normalizeCity(p.city);
  if (city) place.city = city;
  return place;
}

/**
 * Profil mémorisé { pseudo, avatar, place } s'il est valide, sinon null. Un ancien profil sans avatar garde son pseudo (à
 * compléter dans la fenêtre du profil) ; un pseudo généré par une version précédente (`auto`) est oublié.
 * @returns {{pseudo: string, avatar: string|null, place: object|null}|null}
 */
export function resolveProfile(stored) {
  if (!stored || typeof stored !== 'object' || stored.auto === true) return null;
  const pseudo = String(stored.pseudo ?? '').normalize('NFC');
  if (!validatePseudo(pseudo).valid) return null;
  return { pseudo, avatar: avatarById(stored.avatar)?.id ?? null, place: cleanPlace(stored.place) };
}

/** Le profil a tout ce qu'il faut pour signer un score : pseudo et avatar (le lieu est facultatif). */
export const isComplete = (profile) => Boolean(profile?.pseudo && profile.avatar);

/** Ce que submitScore reçoit du profil : pseudo, avatar, et la ville et le pays s'ils sont connus. */
export function signatureOf(profile) {
  const signature = { pseudo: profile.pseudo, avatar: profile.avatar };
  if (profile.place?.city) signature.city = profile.place.city;
  if (profile.place?.countryCode) signature.countryCode = profile.place.countryCode;
  return signature;
}
